import React, { useEffect, useRef,useState } from 'react';
 import { ChevronDown, ArrowRight, Check, Users, Trophy, Globe, Book, Heart, Star } from 'lucide-react';
import Hero from './components/HeroSection';
import NeedForSteam from './components/NeedForSteam';
import WhyTinkerLabs from './components/WhyTinkerLabs';
import BecomeAFranchisee from './components/BecomeAFranchisee';
import CoursesSection from './components/CoursesSection';
import TinkerCourses from './components/TinkerCourses';
import BusinessSuccess from './components/BusinessSuccess';
import FranchiseOptions from './components/FranchiseOptions';
import WhatYouGet from './components/WhatYouGet';
import FranchiseFees from './components/FranchiseFees';
import IndustryFacts from './components/IndustryFacts';
import EurekaMoments from './components/EurekaMoments';
import JoinSection from './components/JoinSection';
import LookingForSection from './components/LookingForSection';
import RoadToSuccess from './components/RoadToSuccess';
import FounderSection from './components/FounderSection';
import FranchiseForm from './components/ContactForm';
import Footer from './components/Footer';


// Utility function for intersection observer
const useIntersectionObserver = (options = {}) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fadeIn');
      }
    }, { threshold: 0.1, ...options });

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  return elementRef;
};

// Main App Component
const App = () => {
  const toSection = (idSection, section=null)=>{
  /*   if (idSection == 'next'){
      const currentSection = sections.indexOf(section);
 
      if (currentSection < sections.length - 1) {
        idSection = sections[currentSection + 1];
      }

    }  */
    const formElement = document.getElementById('contact-form');
        if (formElement) {
          formElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
    
  }
  const sections = [
    'sectio1',
    'sectio2',
    'sectio3',
    'sectio4',
    'sectio5',
    'sectio6',
    'sectio7',
    'sectio8',
    'sectio9',
    'sectio10',
   /*  'sectio11', */
    'sectio12',
    'sectio13',
    'sectio14',
    'sectio15',
    'sectio16',
    'sectio17',
    'sectio18'
    
  ]
  return (
    <div className="font-[Calibri] overflow-x-hidden">
      <style jsx global>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 1s ease-out forwards;
        }
        .section-hidden {
          opacity: 0;
          transform: translateY(20px);
        }
      `}</style>
      <Hero  section="section1" toSection={toSection} />
      <NeedForSteam  section="section2" toSection={toSection} />
      <WhyTinkerLabs section="section3"  toSection={toSection} />
            <FranchiseForm bgColor="transparent" marginBottom={65} section="sectio17" toSection={toSection} />

      <BecomeAFranchisee section="sectio4" toSection={toSection}  />
      <CoursesSection section="sectio5" toSection={toSection}  />
      <TinkerCourses section="sectio6" toSection={toSection}  />
      <BusinessSuccess section="sectio7" toSection={toSection}  />
      <FranchiseOptions section="sectio8" toSection={toSection}  />
      <WhatYouGet section="sectio9" toSection={toSection}  />
      <FranchiseFees section="sectio10" toSection={toSection}  />
      
{/*       <IndustryFacts section="sectio11" toSection={toSection}  />
 */}      <EurekaMoments section="sectio12" toSection={toSection} />
      <JoinSection section="sectio13" toSection={toSection} />
      <LookingForSection section="sectio14" toSection={toSection}  />
      <RoadToSuccess section="sectio15" toSection={toSection} />
      <FounderSection section="sectio16" toSection={toSection} />
      <FranchiseForm section="sectio17" toSection={toSection} />
      <Footer section="sectio18" toSection={toSection} />
    </div>
  );
};


// Animated Section Wrapper
const AnimatedSection = ({ children, className = '' }) => {
  const sectionRef = useIntersectionObserver();
  return (
    <div ref={sectionRef} className={`section-hidden ${className}`}>
      {children}
    </div>
  );
};

   
 

// Would you like me to continue with the remaining sections? I can add more animated components and interactive elements.

export default App;